import { NgModule } from '@angular/core';

import { ScriptService } from './script.service';

@NgModule({
  providers: [ScriptService],
})
export class ScriptModule {}
export { ScriptService };
